import { render } from "./AddAnnouncement.vue?vue&type=template&id=989caed2&scoped=true"
import script from "./AddAnnouncement.vue?vue&type=script&lang=js"
export * from "./AddAnnouncement.vue?vue&type=script&lang=js"

import "./AddAnnouncement.vue?vue&type=style&index=0&id=989caed2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-989caed2"]])

export default __exports__